import { FormattedMessage } from "react-intl";
import { getUserLocal } from "utils/localStorage.util";
// assets
import {
  IconCategory,
  IconShoppingCart,
  IconBuildingStore,
  IconReport,
  IconMilitaryRank,
  IconBuildingSkyscraper,
  IconUsers,
  IconFileText,
  IconQuestionMark,
  IconFolder,
  IconBooks,
  IconListDetails,
  IconCash,
  IconBasket,
  IconCircuitBattery,
  IconLicense,
  IconCreativeCommons,
  IconChartArrowsVertical,
  IconTruckDelivery,
  IconDashboard,
  IconBuildingFactory2,
  IconDiamonds,
  IconDiamond,
  IconPlaneInflight,
  IconBusinessplan,
  IconBrandDeliveroo,
  IconAffiliate,
  IconCategory2,
  IconBrandSlack,
  IconServicemark,
  IconLayersDifference,
  IconBrandProducthunt,
  IconHotelService,
  IconChartArea,
  IconBrandBlender,
} from "@tabler/icons";
// constant
const icons = {
  IconCategory,
  IconBrandBlender,
  IconShoppingCart,
  IconBuildingStore,
  IconReport,
  IconMilitaryRank,
  IconBuildingSkyscraper,
  IconUsers,
  IconFileText,
  IconQuestionMark,
  IconFolder,
  IconBooks,
  IconListDetails,
  IconCash,
  IconBasket,
  IconLicense,
  IconCircuitBattery,
  IconCreativeCommons,
  IconTruckDelivery,
  IconChartArrowsVertical,
  IconDashboard,
  IconBuildingFactory2,
  IconDiamonds,
  IconDiamond,
  IconPlaneInflight,
  IconBusinessplan,
  IconBrandDeliveroo,
  IconAffiliate,
  IconCategory2,
  IconHotelService,
  IconLayersDifference,
  IconServicemark,
  IconBrandProducthunt,
  IconBrandSlack,
  IconChartArea,
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

let cachedUserKey = null;
let cachedParent = null;

const getMenuChildren = () => {
  const userId = getUserLocal();
  const userKey = userId ? `${userId.StaffID || userId._id || ""}_${userId.Type || ""}` : "guest";

  if (cachedParent && cachedUserKey === userKey) {
    return cachedParent;
  }

  cachedUserKey = userKey;
  var Parent = [];
  if (userId) {
    if (userId.Type === "Admin") {
      Parent = [
        {
          id: "default",
          title: "Dashboard",
          type: "item",
          url: "/dashboard",
          icon: icons.IconDashboard,
          breadcrumbs: false,
        },
        {
          id: "company register",
          title: "Company",
          type: "collapse",
          icon: icons.IconBuildingFactory2,
          children: [
            {
              id: "view-company-history",
              title: "Company List",
              type: "item",
              url: "/view-company-history",
              breadcrumbs: false,
            },
            {
              id: "add-company",
              title: "Add Company",
              type: "item",
              url: "/add-company",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "inventory",
          title: "Inventory",
          type: "item",
          url: "/inventory",
          icon: icons.IconBuildingStore,
        },
        {
          id: "banner",
          title: "Banner",
          type: "item",
          url: "/banner",
          icon: icons.IconBooks,
        },
        {
          id: "product",
          title: "Product",
          type: "collapse",
          icon: icons.IconBrandProducthunt,
          breadcrumbs: false,
          children: [
            {
              id: "category",
              title: "Category",
              type: "item",
              url: "/category",
              icon: icons.IconCategory,
            },
            {
              id: "sub-category",
              title: "Sub Category",
              type: "item",
              url: "/sub-category",
              icon: icons.IconCategory2,
            },
            {
              id: "product",
              title: "Product",
              type: "item",
              url: "/product",
              icon: icons.IconShoppingCart,
            },
            {
              id: "admin-joining-kits",
              title: "Joining Kits",
              type: "item",
              url: "/admin/joining-kits",
              icon: icons.IconMilitaryRank,
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "manage area",
          title: "Manage Area",
          type: "collapse",
          icon: icons.IconListDetails,
          children: [
            {
              id: "state",
              title: "State",
              type: "item",
              url: "/state",
              breadcrumbs: false,
            },
            {
              id: "district",
              title: "District",
              type: "item",
              url: "/district",
              breadcrumbs: false,
            },
            // {
            //   id: "block",
            //   title: "Block",
            //   type: "item",
            //   url: "/block",
            //   breadcrumbs: false,
            // },
            // {
            //   id: "cluster",
            //   title: "Cluster",
            //   type: "item",
            //   url: "/cluster",
            //   breadcrumbs: false,
            // },
          ],
        },
        {
          id: "hrm",
          title: "HRM",
          type: "collapse",
          icon: icons.IconUsers,
          breadcrumbs: false,
          children: [
            {
              id: "attedance",
              title: "Attedance",
              type: "item",
              url: "/attedance",
              breadcrumbs: false,
            },
            {
              id: "holidays",
              title: "Holidays",
              type: "item",
              url: "/holidays",
              breadcrumbs: false,
            },
          ],
        },


        {
          id: "incharge",
          title: "Incharge",
          type: "collapse",
          icon: icons.IconChartArrowsVertical,
          breadcrumbs: false,
          children: [
            {
              id: "incharge-tree",
              title: "Hierarchy Tree",
              type: "item",
              url: "/incharge-tree",
              icon: icons.IconAffiliate,
              breadcrumbs: false,
            },
            {
              id: "incharge-state",
              title: "Admin",
              type: "item",
              url: "/franchise-state",
              icon: icons.IconDiamonds,
              breadcrumbs: false,
            },
            {
              id: "incharge-district",
              title: "DSP",
              type: "collapse",
              icon: icons.IconPlaneInflight,
              breadcrumbs: false,
              children: [
                {
                  id: "incharge-district",
                  title: "Active",
                  type: "item",
                  url: "/accept-division",
                  breadcrumbs: false,
                },
                {
                  id: "pending-request",
                  title: "Pending Request",
                  type: "item",
                  url: "/pending-division",
                  breadcrumbs: false,
                },
                {
                  id: "add-new",
                  title: "Add New",
                  type: "item",
                  url: "/add-division",
                  breadcrumbs: false,
                },
              ],
            },
            {
              id: "royalty-clubs",
              title: "Royalty Clubs (5 Slabs)",
              type: "item",
              url: "/royalty-club",
              icon: icons.IconDiamond,
              breadcrumbs: false,
            },
            {
              id: "incharge-block",
              title: "General Manager",
              type: "collapse",
              icon: icons.IconBusinessplan,
              breadcrumbs: false,
              children: [
                {
                  id: "incharge-block",
                  title: "Active",
                  type: "item",
                  url: "/franchise-block",
                  breadcrumbs: false,
                },
                {
                  id: "pending-request",
                  title: "Pending Request",
                  type: "item",
                  url: "/pending-request-block-incharge",
                  breadcrumbs: false,
                },
              ],
            },
            {
              id: "incharge-cluster",
              title: "Marketing Manager",
              type: "collapse",
              icon: icons.IconBrandDeliveroo,
              breadcrumbs: false,
              children: [
                {
                  id: "incharge-block",
                  title: "Active",
                  type: "item",
                  url: "/franchise-cluster",
                  breadcrumbs: false,
                },
                {
                  id: "pending-request",
                  title: "Pending Request",
                  type: "item",
                  url: "/pending-request-Cluster-incharge",
                  breadcrumbs: false,
                },
              ],
            },
            {
              id: "franchise",
              title: "Sales Officer",
              type: "collapse",
              icon: icons.IconBuildingSkyscraper,
              breadcrumbs: false,
              children: [
                {
                  id: "franchise-request",
                  title: "Active",
                  type: "item",
                  url: "/franchise-request",
                  breadcrumbs: false,
                },
                {
                  id: "franchise",
                  title: "Pending Request",
                  type: "item",
                  url: "/franchise",
                  breadcrumbs: false,
                },
              ],
            },
            {
              id: "village",
              title: "Field Officer",
              type: "collapse",
              icon: icons.IconAffiliate,
              breadcrumbs: false,
              children: [
                {
                  id: "village-request",
                  title: "Active",
                  type: "item",
                  url: "/franchise-village",
                  breadcrumbs: false,
                },
                {
                  id: "pending-village",
                  title: "Pending Request",
                  type: "item",
                  url: "/pending-village",
                  breadcrumbs: false,
                },
                {
                  id: "add-franchise-village",
                  title: "Add New",
                  type: "item",
                  url: "/add-franchise-village",
                  breadcrumbs: false,
                },
              ],
            },
          ],
        },

        {
          id: "order",
          title: "Order History",
          type: "collapse",
          icon: icons.IconUsers,
          breadcrumbs: false,
          children: [
            {
              id: "Order History",
              title: "Incharge",
              type: "item",
              url: "/complete-order-by-franchise",
              breadcrumbs: false,
            },
            {
              id: "Farmer Order History",
              title: "Farmer",
              type: "item",
              url: "/complete-order-by-farmer",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "transaction-history",
          title: "Transaction History",
          type: "item",
          url: "/transaction-history",
          icon: icons.IconCash,
        },
        {
          id: "commission-history",
          title: "Commission History",
          type: "item",
          url: "/commission-history",
          icon: icons.IconCreativeCommons,
        },
        {
          id: "weekly-settlement",
          title: "Weekly Settlement",
          type: "item",
          url: "/weekly-settlement",
          icon: icons.IconChartArea,
        },
        {
          id: "incentives",
          title: "Incentives & Rewards",
          type: "item",
          url: "/admin/incentives",
          icon: icons.IconMilitaryRank,
          breadcrumbs: false,
        },
        {
          id: "ledger",
          title: "Ledger",
          type: "item",
          url: "/ledger",
          icon: icons.IconLicense,
        },
        {
          id: "lead",
          title: "Lead",
          type: "collapse",
          icon: icons.IconBrandBlender,
          breadcrumbs: false,
          children: [
            {
              id: "contact-lead",
              title: "ContactUs lead",
              type: "item",
              url: "/view-contact-lead",
              breadcrumbs: false,
            },
          ],
        },

        {
          id: "all-farmers",
          title: "Farmers",
          type: "item",
          url: "/users",
          icon: icons.IconUsers,
          breadcrumbs: false,
          // children: [
          //   {
          //     id: "all-farmers",
          //     title: "Farmers",
          //     type: "item",
          //     url: "/users",
          //     breadcrumbs: false,
          //   },
          // ],
        },
        {
          id: "myCard",
          title: "My Card",
          type: "item",
          url: "/my-card",
          icon: icons.IconLicense,
        },
      ];
    } else {
      // Staff roles: Village (FO), Franchise (SO), Cluster (MM), Block (GM), Division (DSP)
      const isDSP =
        userId.Type === "Division" ||
        userId.Type === "DSP" ||
        userId.Type === "State";

      // Common items for all staff roles
      const commonItems = [
        {
          id: "inchargeDashboard",
          title: "Dashboard",
          type: "item",
          url: "/inchargeDashboard",
          icon: icons.IconDashboard,
        },
        {
          id: "store-purchase",
          title: "Products",
          type: "collapse",
          icon: icons.IconShoppingCart,
          breadcrumbs: false,
          children: [
            {
              id: "products-store",
              title: "Store / Products",
              type: "item",
              url: "/e-commerce/products",
              breadcrumbs: false,
            },
            {
              id: "checkout-cart",
              title: "My Cart / Checkout",
              type: "item",
              url: "/e-commerce/checkout",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "my-orders",
          title: "My Orders",
          type: "item",
          url: "/complete-order-by-franchise",
          icon: icons.IconBasket,
          breadcrumbs: false,
        },
        {
          id: "commission-history",
          title: "Commission History",
          type: "item",
          url: "/inchargeCommission",
          icon: icons.IconCreativeCommons,
        },
      ];

      if (isDSP) {
        // DSP-only menu: Dealer Stock Point (Inventory & Token Fulfillment)
        Parent = [
          ...commonItems,
          {
            id: "dsp-inventory-stock",
            title: "Stock / Inventory",
            type: "item",
            url: "/dsp-inventory",
            icon: icons.IconBuildingStore,
            breadcrumbs: false,
          },
          {
            id: "dsp-token-approvals",
            title: "Token Approvals",
            type: "item",
            url: "/dsp-tokens",
            icon: icons.IconTruckDelivery,
            breadcrumbs: false,
          },
        ];
      } else {
        // FO, SO, MM, GM — full menu with kit activation, hierarchy and recruitment
        Parent = [
          ...commonItems,
          {
            id: "joining-kit-status",
            title: "Joining Kit & Activation",
            type: "item",
            url: "/joining-kit",
            icon: icons.IconMilitaryRank,
            breadcrumbs: false,
          },
          {
            id: "add-field-officer-promotion",
            title: "Add field officer",
            type: "item",
            url: "/add-field-officer-promotion",
            icon: icons.IconUsers,
          },
          {
            id: "staff-network-tree",
            title: "My Hierarchy Tree",
            type: "item",
            url: "/incharge-tree",
            icon: icons.IconAffiliate,
            breadcrumbs: false,
          },
        ];
      }
    }
  }
  cachedParent = Parent;
  return cachedParent;
};

const utilities = {
  id: "utilities",
  title: "Utilities",
  type: "group",
  get children() {
    return getMenuChildren();
  },
};

export default utilities;
